export default __webpack_public_path__ + "static/media/agriculture3.ab26b62d.jpg";